import Suspense from "components/shared/Suspense";
import { ReactNode, lazy } from "react";
import LoadingSpinner from "hardcover-ui/components/LoadingSpinner";
import { Capacitor } from "@capacitor/core";

const PullToRefreshNative = lazy(() => import("./PullToRefreshNative"));

export default function PullToRefresh({
  children,
}: {
  children: ReactNode;
}) {
  if (!Capacitor.isNativePlatform()) {
    return <>{children}</>;
  }

  return (
    <Suspense fallback={<LoadingSpinner variant="layout" size="lg" />}>
      <PullToRefreshNative>{children}</PullToRefreshNative>
    </Suspense>
  );
}
